import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import JurisdictionGroups from './JurisdictionGroups';
import MultiJurisdiction from './MultiJurisdiction';
import React from 'react';
import SourceLinks from '../SourceLinks';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import flattenDeep from 'lodash/flattenDeep';
import unique from 'lodash/uniq';
const apDate = (date) => {
  const months = ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
  return months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
};

const PriorityGroups = (props) => {
  const { priorityGroupsSummary, priorityGroups, country } = props;

  const updatedDates = unique(flattenDeep(
    priorityGroups.jurisdictions
      .map(j => j.phases
        .map(p => p.priorityGroups
          .filter(g => g.priorityConditions)
          .map(g => g.lastUpdated)))));
  updatedDates.sort((a, b) => new Date(b) - new Date(a));
  const lastUpdated = new Date(updatedDates[0]);

  const conditions = unique(flattenDeep(
    priorityGroups.jurisdictions
      .map(j => j.phases
        .map(p => p.priorityGroups
          .filter(g => g.priorityConditions)
          .map(g => g.priorityConditions
            .filter(c => c)
            .map(c => c.type))))))
    .map(c => c.trim().toLowerCase())
    .filter(c => (
      c &&
      c !== 'other' &&
      c !== 'general population'
    ));

  return (
    <div className={classnames(component)}>
      <h4>Vaccination priority groups <small>Last updated {apDate(lastUpdated)}</small></h4>
      <p className=''>People are being offered a vaccine based on —&nbsp;
        {conditions.length ? conditions
          .map(c => (<em key={c}>{c}</em>))
          .reduce((combined, curr, i, { length }) => [combined, (i === length - 1 ? ' and ' : ', '), curr]) : null}.
      </p>
      <div className='source-links'>
        {(priorityGroups.jurisdictions.length === 1) && (priorityGroups.jurisdictions[0].sources.length > 0) && (
          <SourceLinks sources={priorityGroups.jurisdictions[0].sources} />
        )}
      </div>
      <p className='key'>
        <span className='checkmark'><FontAwesomeIcon icon={faCheck} /></span> Can get a COVID-19 vaccine
      </p>
      {priorityGroups.jurisdictions.length === 1 && (
        <JurisdictionGroups jurisdiction={priorityGroups.jurisdictions[0]} />
      )}
      {priorityGroups.jurisdictions.length > 1 && (
        <MultiJurisdiction
          country={country}
          jurisdictions={priorityGroups.jurisdictions}
          priorityGroupsSummary={priorityGroupsSummary}
        />
      )}
    </div>
  );
};

export default PriorityGroups;
